import React, { useState, useEffect } from "react";
import EmbedFlow from "@formsort/react-embed";
import { v4 as uuidv4 } from "uuid";
import "./FormSort.css";

const FormSort = () => {
  const [responderUuid, setResponderUuid] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    const uuid = uuidv4();
    setResponderUuid(uuid);
  }, []);

  const handleStepCompleted = (answers) => {
    console.log("Step completed answers:", answers);
  };

  const handleFlowFinalized = (answers) => {
    console.log("Flow finalized answers:", answers);
    setIsCompleted(true);
  };

  return (
    <div className="formsort-container">
      {responderUuid && (
        <EmbedFlow
          clientLabel="neurovisum16"
          flowLabel="patient-health-questionnaire-phq-9"
          variantLabel="testphase"
          queryParams={[["responderUuid", responderUuid]]}
          embedConfig={{
            style: { width: "100%", height: "100dvh" },
          }}
          onFlowLoaded={() => {
            console.log("Flow has loaded!");  
          }}
          onStepCompleted={handleStepCompleted}
          onFlowFinalized={handleFlowFinalized}
        />
      )}
    </div>
  );
};

export default FormSort;
